import { render, staticRenderFns } from "./FoodItemEditable.vue?vue&type=template&id=6fabef58&scoped=true"
import script from "./FoodItemEditable.vue?vue&type=script&lang=js"
export * from "./FoodItemEditable.vue?vue&type=script&lang=js"
import style0 from "./FoodItemEditable.vue?vue&type=style&index=0&id=6fabef58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fabef58",
  null
  
)

export default component.exports